/**
 * Created by khanhduong on 11/9/17.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function commonReducer(state = initialState.common, action) {
  switch (action.type) {
    case types.COMMON_FETCHING: {
      return state.merge({ fetching: true });
    }
    case types.COMMON_FETCHED: {
      return state.merge({ fetching: false });
    }
    case types.COMMON_UPDATE_TAB_BOTTOM_INDEX: {
      let update = {
        tabBottomIndex: action.index,
      };
      if (action && action.data) {
        update = {
          ...update,
          tabData: action.data,
        };
      }
      return state.merge({ ...update });
    }
    case types.COMMON_TRACKING_ROUTE: {
      return state.setIn(['trackingRoute'], action.route);
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        fetching: false,
        tabBottomIndex: 1,
        trackingRoute: '',
      };
      return state.merge({
        ...reset,
      });
      // console.log("log out membersearchreducer")
    }

    default:
      return state;
  }
}
